import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { ConfirmationData } from "../data-types/confirmation-data";
import { ConfirmationComponent } from "../shared/confirmation/confirmation.component";

@Injectable({
    providedIn: "root",
})
export class DialogService<T> {
    constructor(private _matDialog: MatDialog) {}

    public confirm(): Observable<unknown> {
        let confirmationData: ConfirmationData = {
            isMatDialog: true,
            open: true,
            title: "Confirm Deletion?",
            detail: "Confirm Deletion?",
            cancelButtonText: "Cancel",
            buttonText: "Confirm",
            data: {},
            type: "",
        };
        
        const dialogRef = this._matDialog.open(ConfirmationComponent);
        const componentInstance = dialogRef.componentInstance;
        componentInstance.data = confirmationData;

        return dialogRef.afterClosed();
    }
}
